<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded1">
<p class="center"><em>To Kim—<br/>We look forward to sharing<br/>with you the table He has<br/>prepared for us.<br/>Psalm 23: 1–6<br/>With love,<br/>Blake, Brooke, and Roxie</em></p>
<p class="center"><img alt="" src="OEBPS/images/9781449400217_ded2.jpg"/><br/><br/></p>
<p class="center"><em>To my dad, Tom Reeves—<br/>For teaching me to find art in words.<br/>Love, Shelly</em></p>
<p class="center"><img alt="" src="OEBPS/images/9781449400217_ded3.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781449400217_epub_ded1_r1.vue?1f36e27d